<h1 mat-dialog-title>{{ 'Redirect to Leasing Portal' | translate }}</h1>
<div mat-dialog-content class="content">
  <p>{{ 'Please note you are being redirected to the new leasing login and will need to sign in again.' | translate }}</p>
  <p>{{ 'Thank you for your understanding while we create a new better user experience.' | translate }}</p>
</div>
<div mat-dialog-actions class="control">
  <button mat-button mat-dialog-close>{{ 'Cancel' | translate }}</button>
  <button mat-button  color="primary" (click)="onProceedClicked()" cdkFocusInitial>{{ 'Proceed' | translate}}</button>
</div>